const baseTimes =  [
    {
        'key': '1h',
        'text': '1H',
        'value': 1
    },
    {
        'key': '3h',
        'text': '3H',
        'value': 3
    },
    {
        'key': '12h',
        'text': '12H',
        'value': 12
    },
    {
        'key': '1d',
        'text': '1D',
        'value': 24
    },
    {
        'key': '3d',
        'text': '3D',
        'value': 72
    },
    {
        'key': '7d',
        'text': '1W',
        'value': 7
    },
    {
        'key': '30d',
        'text': '1M',
        'value': 30
    }
]
const timesDataFactory = (type) => {
    const typeConfigurations = {
        uptime_monitoring: (data) => data.map((item) => {
            if (item.key === '1h') return {...item, interval: 'minute', limit: 60}
            if (item.key === '3h') return {...item, interval: 'minute', limit: 180}
            if (item.key === '12h') return {...item, interval: 'hour', limit: 12}
            if (item.key === '1d') return {...item, interval: 'hour', limit: 24}
            if (item.key === '3d') return {...item, interval: 'hour', limit: 72}
            if (item.key === '7d') return {...item, interval: 'day', limit: 7}
            if (item.key === '30d') return {...item, interval: 'day', limit: 30}
            return item
        }),
        server_monitoring: (data) => data.map((item) => {
            if (item.key === '1h' || item.key === '3h') return {...item, interval: 'on-demand'}
            if (['12h', '1d', '3d'].includes(item.key)) return {...item, interval: 'hour'}
            if (item.key === '7d') return {...item, interval: 'hour', value: 168}
            if (item.key === '30d') return {...item, interval: 'day'}
            return item
        }),
        heartbeat_monitoring: (data) => data.map((item) => {
            if (item.key === '7d' || item.key === '30d') return {...item, interval: item.key, value: 24 * item.value}
            return {...item, interval: item.key}
        })
    }

    const applyConfiguration = typeConfigurations[type] || typeConfigurations.uptime_monitoring

    return applyConfiguration([...baseTimes])
}

export {
    timesDataFactory
}
